import revealChat from "assets/svg/revealChat.svg";
import styles from "./index.module.css";
import { ModalComponentV1 } from "Components/ModalComponentV1";
import { CustomButton } from "Components/CustomButton";

type Props = {
  onTakeAndSand: () => void;
  onCancel: () => void;
  isOpen: boolean;
};
export const TakeSessionComponent = ({ onCancel, onTakeAndSand, isOpen }: Props) => {
  return (
    <ModalComponentV1 title="Take Session" onClose={onCancel} isOpen={isOpen} is24padding>
      <div>
        <div className={styles.contentWrapper}>
          <img src={revealChat} alt="chat img" width={48} height={48} />
          <span>Are you sure that you want to take the session and send the message?</span>
        </div>
        <div className={styles.btnWrapper}>
          <CustomButton typeButton="tertiary" sizeButton="large" onClick={onCancel}>
            <div>Cancel</div>
          </CustomButton>
          <CustomButton typeButton="primary" sizeButton="large" onClick={onTakeAndSand}>
            <div>Take and Send</div>
          </CustomButton>
        </div>
      </div>
    </ModalComponentV1>
  );
};
